document.addEventListener('DOMContentLoaded', function() {
  function attachProductListeners(container) {
    container.querySelectorAll('.js-show-sizes').forEach(button => {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        const productWrapper = this.closest('.product-item_image-link');
        const sizeWrapper = productWrapper.querySelector('.product-item_size_wrapper');
        
        if (sizeWrapper) {
          if (sizeWrapper.style.display === 'none' || sizeWrapper.style.display === '') {
            sizeWrapper.style.display = 'block';
          } else {
            sizeWrapper.style.display = 'none';
          }
        }
      });
    });
    
    container.querySelectorAll('.js-size-select').forEach(button => {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        if (this.disabled) {
          return;
        }
        
        const productWrapper = this.closest('.product-item_image-link');
        const variantInventory = this.dataset.variantInventory ? parseInt(this.dataset.variantInventory) : 0;
        
        const allSizeButtons = productWrapper.querySelectorAll('.js-size-select:not([disabled])');
        allSizeButtons.forEach(btn => {
          btn.classList.remove('active');
        });
        
        this.classList.add('active');
        const addToCartBtn = productWrapper.querySelector('.js-add-to-cart');
        if (addToCartBtn) {
          addToCartBtn.dataset.variantId = this.dataset.variantId;
          addToCartBtn.disabled = false;
          addToCartBtn.style.opacity = '1';
          addToCartBtn.style.cursor = 'pointer';
          const stockSpan = addToCartBtn.querySelector('.js-stock-text');
          if (stockSpan) {
            if (variantInventory > 0) {
              stockSpan.textContent = `${variantInventory} IN STOCK`;
            } else {
              stockSpan.textContent = '';
            }
          }
        }
      });
    });

    container.querySelectorAll('.js-add-to-cart').forEach(button => {
      button.addEventListener('click', async function(e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        
        const productWrapper = this.closest('.product-item_image-link');
        if (this.disabled) {
          return;
        }
        if (this.classList.contains('loading')) {
          return;
        }
        let variantId = this.dataset.variantId;
        
        if (!variantId) {
          const firstAvailableSize = productWrapper.querySelector('.js-size-select:not([disabled])');
          if (firstAvailableSize) {
            variantId = firstAvailableSize.dataset.variantId;
            firstAvailableSize.classList.add('active');
            this.dataset.variantId = variantId;
          } else {
            return;
          }
        }
        
        this.classList.add('loading');
        
        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              id: variantId,
              quantity: 1
            })
          });
          
          if (!response.ok) {
            throw new Error('Failed to add to cart');
          }
          
          const cartData = await response.json();
          
          this.classList.remove('loading');
          
          const successMessage = productWrapper.querySelector('.product-item_added-message');
          
          if (successMessage) {
            successMessage.style.display = 'block';
            
            setTimeout(() => {
              successMessage.style.display = 'none';
            }, 2000);
          }
          
          const cartCountElements = document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"]');
          cartCountElements.forEach(el => {
            el.textContent = cartData.item_count;
          });
          
          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer) {
            cartDrawer.open();
            
            setTimeout(() => {
              fetch('/?section_id=cart-drawer')
                .then(response => response.text())
                .then(responseText => {
                  const html = new DOMParser().parseFromString(responseText, 'text/html');
                  const newCartDrawer = html.querySelector('cart-drawer');
                  
                  if (newCartDrawer) {
                    const oldCartDrawerInner = cartDrawer.querySelector('.drawer__inner');
                    const newCartDrawerInner = newCartDrawer.querySelector('.drawer__inner');
                    
                    if (newCartDrawerInner && oldCartDrawerInner) {
                      oldCartDrawerInner.innerHTML = newCartDrawerInner.innerHTML;
                    }
                    
                    if (cartData.item_count === 0) {
                      cartDrawer.classList.add('is-empty');
                    } else {
                      cartDrawer.classList.remove('is-empty');
                    }
                  }
                })
                .catch(() => {});
            }, 300);
          }
          
        } catch {
          this.classList.remove('loading');
          this.classList.add('error');
          
          setTimeout(() => {
            this.classList.remove('error');
          }, 2000);
        }
      });
    });
  }

  function addWebflowAttributes(container) {
    const firstProduct = document.querySelector('.w-dyn-item');
    if (!firstProduct) return;
    
    const originalImageWrapper = firstProduct.querySelector('.product-item_image-wrapper');
    const originalCartWrapper = firstProduct.querySelector('.product-item_add-to-cart-wrapper');
    const originalSizeWrapper = firstProduct.querySelector('.product-item_size_wrapper');
    
    if (!originalImageWrapper) return;
    
    const imageWrapperId = originalImageWrapper.getAttribute('data-w-id');
    const cartWrapperId = originalCartWrapper ? originalCartWrapper.getAttribute('data-w-id') : '04811a54-1916-43e9-de2b-c1aecf1d8d14';
    const sizeWrapperId = originalSizeWrapper ? originalSizeWrapper.getAttribute('data-w-id') : '2b0fbfaf-4eaa-c4f8-923d-85a51fef6788';
    
    container.querySelectorAll('.product-item_image-wrapper:not([data-w-id])').forEach((el, index) => {
      el.setAttribute('data-w-id', imageWrapperId);
    });
    
    container.querySelectorAll('.product-item_add-to-cart-wrapper:not([data-w-id])').forEach((el, index) => {
      el.setAttribute('data-w-id', cartWrapperId);
    });
    
    container.querySelectorAll('.product-item_size_wrapper:not([data-w-id])').forEach((el, index) => {
      el.setAttribute('data-w-id', sizeWrapperId);
    });
  }

  const root = document.getElementById('ProductGridContainer') || document;
  attachProductListeners(root);
  addWebflowAttributes(root);
});